import React from 'react';

import KeysListHeader from './KeysListHeader';
import KeysListTable from './KeysListTable';

const KeysList: React.FC = () => (
    <>
        <KeysListHeader />
        <KeysListTable />
    </>
);

export default KeysList;
